module.exports = __webpack_public_path__ + "static/media/flagBrasil.70480679.svg";